<select #comboBox
  [(ngModel)]="selectedMiddleClassCode" [disabled]="disabled" [hidden]="!visible"
  (change)="update($event);onChange($any($event.target).value);" (blur)="onTouched()"
  [style.width.px]="width" [style.width]="width !== undefined ? width : '100%'"
  [tabindex]="tabindex" [class.combo-box-required]="required">
  <ng-template ngFor let-item [ngForOf]="model.middleClassList">
    <option value="{{item.MiddleClassCode}}">{{item.MiddleClassCodeName}}</option>
  </ng-template>
</select>
